// export action types
import { UPDATE_MEMBER_VERIFICATION_STATE, CLEAR_MEMBER_VERIFICATION_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { updateMemberVerificationState } from 'actions/updateMemberVerificationState';
 *
 * // dispatch action
 * store.dispatch( updateMemberVerificationState( payload ) );
 */
export const updateMemberVerificationState = ( payload ) => {
    return {
        type: UPDATE_MEMBER_VERIFICATION_STATE,
        payload: payload
    };
};


export const clearMemberVerificationState = ( ) => {
    return {
        type: CLEAR_MEMBER_VERIFICATION_STATE,
        payload: null
    };
};
